<template>
  <div class="d-flex justify-content-between align-items-center w-100 m-2" @click.stop>
    <button
      @click="moveToPrevImage"
      class="nav-button d-flex align-items-center justify-content-center"
    >
      <svg width="21" height="18" class="icon">
        <use xlink:href="#___icon___chevron-left-bold"></use>
      </svg>
    </button>
    <div class="full-screen-container position-relative" @click.stop>
      <div class="d-flex justify-content-end align-item-center pb-2">
        <button @click="toggleFullScreen()" class="close-fullscreen">
          <svg width="21" height="21" class="icon">
            <use xlink:href="#___icon___close-x"></use>
          </svg>
        </button>
      </div>
      <div class="img-section-name">
        <img
          :src="imageUrl"
          class="full-screen-image w-100"
          alt="Full Screen Image"
        />
        <div class="body section-name-mob">{{ currentSectionName }}</div>
      </div>
      <div class="image-info">
        <div class="section-name">{{ currentSectionName }}</div>
        <div class="caption image-counter-desktop">
          {{ currentIndex + 1 }}/{{ totalImages }}
        </div>
      </div>
    </div>
    <button
        @click="moveToNextImage"
        class="nav-button d-flex align-items-center justify-content-center"
      >
      <svg width="21" height="18" class="icon">
        <use xlink:href="#___icon___chevron-right-bold"></use>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    image: Object,
    currentIndex: Number,
    totalImages: Number,
    currentSectionName: String,
  },
  data() {
    return {
      localCurrentIndex: this.currentIndex,
      localTotalImages: this.totalImages,
    };
  },
  computed: {
    imageUrl() {
      if(!this.image) return ""
      return this.image.imgXL || this.image.imgLarge || this.image.img;
    },
  },
  methods: {
    toggleFullScreen() {
      this.$emit("toggleFullScreen");
    },
    moveToPrevImage() {
      if (this.localCurrentIndex > 0) {
        this.localCurrentIndex--;
        this.$emit("updateIndex", this.localCurrentIndex);
      }
    },
    moveToNextImage() {
      if (this.localCurrentIndex < this.localTotalImages - 1) {
        this.localCurrentIndex++;
        this.$emit("updateIndex", this.localCurrentIndex);
      }
    },
  },
  watch: {
    currentIndex(newVal) {
      this.localCurrentIndex = newVal;
    },
    totalImages(newVal) {
      this.localTotalImages = newVal;
    },
  },
};
</script>

<style scoped>
.full-screen-container {
  width: 50vw;
}

.full-screen-image {
  height: auto;
  object-fit: contain;
  border-radius: 8px;
}

.section-name-mob {
  display: none;
}

.nav-button {
  border-radius: 32px;
  border: 1px solid var(--grey-grey-300, #dee2e6);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  cursor: pointer;
  width: 30px;
  height: 30px;
}

.image-info {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: white;
  font-size: 16px;
  box-sizing: border-box;
}

.section-name {
  padding: 5px 10px;
  border-radius: 5px;
}

.close-fullscreen {
  background: none;
  border: none;
  cursor: pointer;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #f1f3f5;
}
</style>